export default __webpack_public_path__ + "static/media/product-10 (1).8dc3aee3.jpg";